import { giphyDarkCharcoal, giphyWhite } from '@giphy/js-brand'
import { EllipsisDropdown } from '@giphy/react-giphy-brand'
import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolGradient from '../../../../../types/gradient'
import { GradientButton } from '../../../../buttons'
import { CreationCaptureInfoContext } from '../../../../supercut/shared/components/capture-info/manager'
import { IWatermark } from '../../types'

const Preview = styled.div`
    height: 50px;
    background-color: ${giphyDarkCharcoal};
    margin: 8px 0px;
    text-align: center;
    display: flex;
    align-items: center;
    border-radius: 4px;
`

const ChooseButton = styled(GradientButton)`
    width: 110px;
    height: 32px;
    flex: 1;
    margin: 0px 5px;
`
const Image = styled.div<{ src: string }>`
    background-image: url(${props => props.src});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    height: 50px;
    width: 50px;
    margin-right: 14px;
`
const Title = styled.div`
    flex: 3;
    text-align: left;
    font-weight: bold;
    color: ${giphyWhite};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const EllipsisButton = styled.div`
    cursor: pointer;
    color: ${giphyWhite};
    height: 30px;
    margin-right: 5px;
`

const EllipsisItem = styled.div`
    cursor: pointer;
`

type Props = {
    watermark: IWatermark
    currentlySelected: boolean
}

const WatermarkPreviewItem = ({ watermark, currentlySelected }: Props) => {
    const { setWatermark, setPreviousWatermarks, previousWatermarks } = useContext(CreationCaptureInfoContext)

    const onChooseClick = () => {
        if (currentlySelected) {
            setWatermark()
        } else {
            setWatermark(watermark)
        }
    }

    const onDelete = () => {
        if (currentlySelected) {
            setWatermark()
        }
        setPreviousWatermarks(previousWatermarks.filter(wm => wm.id !== watermark.id))
    }

    return (
        <Preview>
            <Image src={watermark.image}></Image>
            <Title>{watermark.title}</Title>
            <ChooseButton
                colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}
                onClick={onChooseClick}
            >
                {currentlySelected ? 'Remove' : 'Choose'}
            </ChooseButton>
            <EllipsisButton onClick={evt => evt.stopPropagation()}>
                <EllipsisDropdown isHover={true} extendDirectionUp={true}>
                    <EllipsisItem onClick={onDelete}>Delete</EllipsisItem>
                </EllipsisDropdown>
            </EllipsisButton>
        </Preview>
    )
}

export default WatermarkPreviewItem
